import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import moment from 'moment';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import EmptyComponent from '../../../component/EmptyComponent';
import {
  DeleteBlogger,
  GetBlogger,
  SearchForBlogsByTitle,
} from '../../../redux/admin/bloggers/bloggersServicesSync';
import {
  updateAllPage,
  updateLoaderIndicator,
  updateSingleBlogDetails,
} from '../../../redux/admin/bloggers/bloggersSlices';
import { InfinitySpin } from 'react-loader-spinner';
import { useDebouncedCallback } from 'use-debounce';

const Blogs = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [searchBlog, setSearchBlog] = useState('');

  const {
    storiesPageLoad,
    articleDetails,
    allLimit,
    allPage,
    isBlogLoading,
    loaderIndicator,
    articleDetailsSearch,
  } = useSelector((state) => state.blogger);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    dispatch(
      GetBlogger({
        page: allPage,
        limit: allLimit,
      })
    );

    return () => {
      dispatch(updateAllPage(0));
    };
  }, []);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (selectedItem) {
      dispatch(updateLoaderIndicator(selectedItem?._id));
      dispatch(
        DeleteBlogger({
          ...selectedItem,
          publish: !selectedItem?.publish,
        })
      );
      setShowDeleteModal(false);
      setSelectedItem(null);
    }
  };

  const handlePageChange = (page) => {
    dispatch(
      GetBlogger({
        page: page,
        limit: allLimit,
      })
    );
  };

  const debounced = useDebouncedCallback(
    async (value) => {
      if (value) {
        dispatch(
          SearchForBlogsByTitle({
            title: value,
            page: 0,
            limit: allLimit,
          })
        );
      }
    },
    // delay in ms
    1000
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchBlog(value);

    if (value) {
      debounced(value);
    }
  };

  return (
    <>
      <div class="card max-w-[500px]">
        <div class="card-header">
          <form class="chat-search pb-0">
            <div class="chat-search-box">
              <input
                value={searchBlog || ''}
                class="form-control"
                type="text"
                name="search"
                placeholder="Search ..."
                onChange={handleInputChange}
              />

              <button type="submit" class="btn btn-sm btn-link search-icon p-0">
                <i class="bx bx-search-alt"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center gap-1">
              <h4 class="card-title flex-grow-1">All Product List</h4>

              <NavLink to="/admin_dashboard/create_blog">
                <a class="btn btn-sm btn-primary">Add Blog</a>
              </NavLink>
            </div>
            <div>
              {storiesPageLoad ? (
                <TableLoader
                  headerArray={[
                    'Title',
                    'Hash Tag',
                    'Publish',
                    'Date',
                    'Action',
                  ]}
                  itemArray={[1, 2, 3, 4, 5]}
                />
              ) : (
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-hover table-centered">
                    <thead class="bg-light-subtle">
                      <tr>
                        <th style={{ width: '20px' }}>
                          <div class="form-check ms-1">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="customCheck1"
                            />
                            <label
                              class="form-check-label"
                              for="customCheck1"
                            ></label>
                          </div>
                        </th>
                        <th>Title</th>
                        <th>Hash Tag</th>
                        <th>Publish</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchBlog ? (
                        articleDetailsSearch?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          articleDetailsSearch?.docs?.map((item, key) => (
                            <>
                              {item?._id !== loaderIndicator ? (
                                <tr key={key}>
                                  <td>
                                    <div class="form-check ms-1">
                                      <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="customCheck2"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="customCheck2"
                                      >
                                        &nbsp;
                                      </label>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                        <img
                                          src={item?.cover_pic}
                                          alt=""
                                          class="avatar-md"
                                        />
                                      </div>
                                      <div>
                                        <a
                                          href="#!"
                                          class="text-dark fw-medium fs-15"
                                        >
                                          {item?.title}
                                        </a>
                                      </div>
                                    </div>
                                  </td>

                                  <td>{item?.hash_tag}</td>

                                  <td>
                                    <p
                                      class={`${
                                        item?.publish
                                          ? 'text-success'
                                          : 'text-danger'
                                      }`}
                                    >
                                      {item?.publish ? 'visible' : 'invisible'}
                                    </p>
                                  </td>

                                  <td>
                                    {`${moment(item?.date).format(
                                      'dd MM YYYY'
                                    )}`}
                                  </td>
                                  <td>
                                    <div class="d-flex gap-2">
                                      <a
                                        onClick={() => {
                                          navigate(
                                            `/admin_dashboard/view_blog/${item?.title}@${item?._id}`
                                          );
                                        }}
                                        class="btn btn-light btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:eye-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>

                                      <a
                                        onClick={() => {
                                          dispatch(
                                            updateSingleBlogDetails(item)
                                          );

                                          navigate(
                                            '/admin_dashboard/edit_blog'
                                          );
                                        }}
                                        class="btn btn-soft-primary btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:pen-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>

                                      <a
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleDeleteClick(item);
                                        }}
                                        className="btn btn-soft-danger btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:trash-bin-minimalistic-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <SingleTableLoader
                                  itemArray={[1, 2, 3, 4, 5]}
                                />
                              )}
                            </>
                          ))
                        )
                      ) : articleDetails?.docs?.length <= 0 ? (
                        <EmptyComponent />
                      ) : (
                        articleDetails?.docs?.map((item, key) => (
                          <>
                            {item?._id !== loaderIndicator ? (
                              <tr key={key}>
                                <td>
                                  <div class="form-check ms-1">
                                    <input
                                      type="checkbox"
                                      class="form-check-input"
                                      id="customCheck2"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="customCheck2"
                                    >
                                      &nbsp;
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <div class="d-flex align-items-center gap-2">
                                    <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                      <img
                                        src={item?.cover_pic}
                                        alt=""
                                        class="avatar-md"
                                      />
                                    </div>
                                    <div>
                                      <a
                                        href="#!"
                                        class="text-dark fw-medium fs-15"
                                      >
                                        {item?.title}
                                      </a>
                                    </div>
                                  </div>
                                </td>

                                <td>{item?.hash_tag}</td>

                                <td>
                                  <p
                                    class={`${
                                      item?.publish
                                        ? 'text-success'
                                        : 'text-danger'
                                    }`}
                                  >
                                    {item?.publish ? 'visible' : 'invisible'}
                                  </p>
                                </td>

                                <td>
                                  {`${moment(item?.date).format('dd MM YYYY')}`}
                                </td>
                                <td>
                                  <div class="d-flex gap-2">
                                    <a
                                      onClick={() => {
                                        navigate(
                                          `/admin_dashboard/view_blog/${item?.title}@${item?._id}`
                                        );
                                      }}
                                      class="btn btn-light btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:eye-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>

                                    <a
                                      onClick={() => {
                                        dispatch(updateSingleBlogDetails(item));

                                        navigate('/admin_dashboard/edit_blog');
                                      }}
                                      class="btn btn-soft-primary btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:pen-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>

                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDeleteClick(item);
                                      }}
                                      className="btn btn-soft-danger btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:trash-bin-minimalistic-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <SingleTableLoader itemArray={[1, 2, 3, 4, 5]} />
                            )}
                          </>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div class="card-footer border-top">
              <nav aria-label="Page navigation example">
                <PaginationComponent
                  currentPage={articleDetails?.page}
                  totalItems={articleDetails?.totalDocs}
                  pageSize={allLimit}
                  handlePageChange={handlePageChange}
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <div
          className="modal-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            className="modal-container"
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '400px',
            }}
          >
            <div className="modal-header">
              <h5>
                {selectedItem?.publish ? <>Delete Blog</> : <>Publish Blog</>}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowDeleteModal(false)}
              />
            </div>
            <div className="modal-body" style={{ padding: '20px 0' }}>
              <p>
                Are you sure you want to{' '}
                <b>{`${
                  selectedItem?.publish ? 'delete' : 'publish'
                } the Blog`}</b>
                ?
              </p>
            </div>
            <div
              className="modal-footer"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className="btn bg-gray-300"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleConfirmDelete}>
                {isBlogLoading ? (
                  <div class="form-group col-sm-9">
                    <InfinitySpin width="100" color="#FFFFFF" />
                  </div>
                ) : (
                  <>{selectedItem?.publish ? 'Delete' : 'Publish'}</>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Blogs;
